import { render, staticRenderFns } from "./CoreanosList.vue?vue&type=template&id=526affa0&scoped=true"
import script from "./CoreanosList.vue?vue&type=script&lang=js"
export * from "./CoreanosList.vue?vue&type=script&lang=js"
import style0 from "./CoreanosList.vue?vue&type=style&index=0&id=526affa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526affa0",
  null
  
)

export default component.exports